import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({
  title,
  description,
  keywords = [],
  author = "Meetworkplace",
  type = "website",
  image = "https://tomeetworkplace.com/logo512.png",
  structuredData = null,
  canonical = null
}) => {
  const location = useLocation();
  const baseUrl = "https://tomeetworkplace.com";
  const currentUrl = canonical || `${baseUrl}${location.pathname}`;

  useEffect(() => {
    // Set document title
    document.title = title || "Meetworkplace - Enterprise Social Network for Employee Retention";

    // Update or create meta tags
    const updateMeta = (name, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attr}="${name}"]`);

      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, name);
        document.head.appendChild(element);
      }

      element.setAttribute('content', content);
    };

    // Standard meta tags
    if (description) {
      updateMeta('description', description);
    }

    if (keywords.length > 0) {
      updateMeta('keywords', keywords.join(', '));
    }

    updateMeta('author', author);

    // OpenGraph meta tags (Facebook, LinkedIn)
    updateMeta('og:title', title, true);
    updateMeta('og:description', description || '', true);
    updateMeta('og:type', type, true);
    updateMeta('og:url', currentUrl, true);
    updateMeta('og:image', image, true);
    updateMeta('og:site_name', 'Meetworkplace', true);
    updateMeta('og:locale', 'en_US', true);

    // Twitter Card meta tags
    updateMeta('twitter:card', 'summary_large_image');
    updateMeta('twitter:site', '@meetworkplace');
    updateMeta('twitter:title', title);
    updateMeta('twitter:description', description || '');
    updateMeta('twitter:image', image);
    updateMeta('twitter:creator', '@meetworkplace');

    // Canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', currentUrl);

    // Structured Data (JSON-LD)
    if (structuredData) {
      let scriptTag = document.querySelector('script[type="application/ld+json"]');
      if (!scriptTag) {
        scriptTag = document.createElement('script');
        scriptTag.setAttribute('type', 'application/ld+json');
        document.head.appendChild(scriptTag);
      }
      scriptTag.textContent = JSON.stringify(structuredData);
    }

  }, [title, description, keywords, author, type, image, currentUrl, structuredData]);

  return null;
};

export default SEO;
